module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p'), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_c('b', [_vm._v("PUBLISHER:")]), _vm._v(" Amy Marson")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_c('b', [_vm._v("CREATIVE DIRECTOR:")]), _vm._v(" Gailen Runge")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_c('b', [_vm._v("ART DIRECTOR:")]), _vm._v(" Kristy Zacharias")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_c('b', [_vm._v("EDITOR:")]), _vm._v(" Liz Aneloski")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_c('b', [_vm._v("TECHNICAL EDITORS:")]), _vm._v(" Doreen Hazel and Gailen Runge")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_c('b', [_vm._v("COVER/BOOK DESIGNER:")]), _vm._v(" April Mostek")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_c('b', [_vm._v("PRODUCTION COORDINATOR:")]), _vm._v(" Rue Flaherty")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_c('b', [_vm._v("PRODUCTION EDITOR:")]), _vm._v(" Joanna Burgarino")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_c('b', [_vm._v("ILLUSTRATOR:")]), _vm._v(" Jessica Jenkins")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_c('b', [_vm._v("PHOTO ASSISTANT:")]), _vm._v(" Mary Peyton Peppo")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_c('b', [_vm._v("STYLED PHOTOGRAPHY")]), _vm._v(" by Nissa Brehmer and"), _c('br'), _c('b', [_vm._v("INSTRUCTIONAL PHOTOGRAPHY")]), _vm._v(" by Diane Pedersen, unless otherwise noted")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-715ab206","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/03_copyright.vue
// module id = 60
// module chunks = 0